// @flow

import React from 'react';
export function MerchandisingIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.43304 1.80277L0.955419 4.66852C0.874148 5.15614 1.25018 5.60004 1.74453 5.60004H2.45852C2.91305 5.60004 3.32857 5.34324 3.53184 4.93669L4.00017 4.00004L4.46849 4.93669C4.67176 5.34324 5.08728 5.60004 5.54181 5.60004H6.45852C6.91305 5.60004 7.32857 5.34324 7.53184 4.93669L8.00017 4.00004L8.46849 4.93669C8.67176 5.34324 9.08728 5.60004 9.54181 5.60004H10.4585C10.9131 5.60004 11.3286 5.34324 11.5318 4.93669L12.0002 4.00004L12.4685 4.93669C12.6718 5.34324 13.0873 5.60004 13.5418 5.60004H14.2558C14.7501 5.60004 15.1262 5.15614 15.0449 4.66852L14.5673 1.80277C14.4708 1.22414 13.9702 0.800049 13.3836 0.800049H2.61672C2.03011 0.800049 1.52948 1.22414 1.43304 1.80277Z"
        fill="#00A0AC"
      />
      <path
        d="M14.4002 7.20005H1.60017V14C1.60017 14.6628 2.13742 15.2 2.80017 15.2H5.60017V9.60005H10.4002V15.2H13.2002C13.8629 15.2 14.4002 14.6628 14.4002 14V7.20005Z"
        fill="#00A0AC"
      />
    </svg>
  );
}
